<template>
  <div class="wrapper">
    <!-- <div class="wrapper" :class="{'nav-open': $sidebar.showSidebar}"> -->

    <side-bar :background-color="backgroundColor">
      <!-- <mobile-menu slot="content"></mobile-menu> -->
      <sidebar-link to="/hot_clients">
        <i class="tim-icons icon-time-alarm" style="color: #ffa7b2"></i>
        <template>
          <p>Клиенты под обзвон</p>
        </template>
      </sidebar-link>
      <sidebar-link to="/clients">
        <i class="tim-icons icon-single-02"></i>
        <template>
          <p>Клиенты</p>
        </template>
      </sidebar-link>
      <sidebar-link to="/calls">
        <i class="tim-icons icon-send"></i>
        <template>
          <p>Звонки</p>
        </template>
      </sidebar-link>
      <sidebar-link to="/tsrs">
        <i class="tim-icons icon-atom"></i>
        <template>
          <p>ТСР</p>
        </template>
      </sidebar-link>
      <sidebar-link to="/base_tsrs">
        <i class="tim-icons icon-puzzle-10"></i>
        <template>
          <p>Базовые ТСР</p>
        </template>
      </sidebar-link>
      <sidebar-link to="/compensations">
        <i class="tim-icons icon-money-coins"></i>
        <template>
          <p>Компенсации</p>
        </template>
      </sidebar-link>
      <sidebar-link to="/products">
        <i class="tim-icons icon-bag-16"></i>
        <template>
          <p>Номенклатура</p>
        </template>
      </sidebar-link>
      <sidebar-link to="/directories">
        <i class="tim-icons icon-book-bookmark"></i>
        <template>
          <p>Справочники</p>
        </template>
      </sidebar-link>
      <sidebar-link v-if="isAdmin" to="/loggs">
        <i class="tim-icons icon-align-left-2"></i>
        <template>
          <p>Логи</p>
        </template>
      </sidebar-link>
      <sidebar-link v-if="isAdmin" to="/doc_patterns">
        <i class="tim-icons icon-single-copy-04"></i>
        <template>
          <p>Шаблоны документов</p>
        </template>
      </sidebar-link>
      <sidebar-link v-if="isDeveloper" to="/dashboard">
        <i class="tim-icons icon-chart-pie-36"></i>
        <template>
          <p>Dashboard</p>
        </template>
      </sidebar-link>
      <sidebar-link v-if="isDeveloper" to="/icons">
        <i class="tim-icons icon-atom"></i>
        <template>
          <p>Icons</p>
        </template>
      </sidebar-link>
      <sidebar-link v-if="isDeveloper" to="/notifications">
        <i class="tim-icons icon-bell-55"></i>
        <template>
          <p>Notifications</p>
        </template>
      </sidebar-link>
      <sidebar-link v-if="isDeveloper" to="/user">
        <i class="tim-icons icon-single-02"></i>
        <template>
          <p>User Profile</p>
        </template>
      </sidebar-link>
      <sidebar-link v-if="isDeveloper" to="/table">
        <i class="tim-icons icon-puzzle-10"></i>
        <template>
          <p>Table List</p>
        </template>
      </sidebar-link>
      <sidebar-link v-if="isDeveloper" to="/typography">
        <i class="tim-icons icon-align-center"></i>
        <template>
          <p>Typography</p>
        </template>
      </sidebar-link>
    </side-bar>

    <div class="main-panel" :data="backgroundColor">
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar"></dashboard-content>

      <content-footer></content-footer>
    </div>

  </div>
</template>
<style lang="scss"></style>
<script>

import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./DashboardContent.vue";
import SidebarShare from "./SidebarSharePlugin.vue";
import MobileMenu from "./MobileMenu.vue";
import SideBar from "@/components/SidebarPlugin/SideBar.vue";
import SidebarLink from "@/components/SidebarPlugin/SidebarLink.vue";
import {developer} from "@/main";
import {userService} from "@/services/user.service";



export default{
  components: {
    TopNavbar,
    DashboardContent,
    ContentFooter,
    MobileMenu,
    SideBar,
    SidebarLink
  },
  data() {
    return {
      backgroundColor: "blue"
    };
  },
  computed: {
    isDeveloper() {
      return userService.getUser().id === 1;
    },
    isAdmin() {
      return userService.isDeleteAllowed() || userService.getUser().id === 1;
    }
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
};
</script>
